import StoniTenis from './StoniTenis'

const Esports = () => <StoniTenis calculatorType='Esports' />

export default Esports
